/***
 * TinyAutocomplete changes based on Summon needs.
*/

(function (window, $) {
  var TinyAutocomplete = $.tinyAutocomplete;

  /***
   * Monkey patch for markSelected to set the aria selected attribute according to the selection
   * @type {TinyAutocomplete.markSelected|markSelected}
   */
  TinyAutocomplete.prototype.patchedMarkSelected = TinyAutocomplete.prototype.markSelected;

  TinyAutocomplete.prototype.markSelected = function (i) {
    this.el.find("[aria-selected='true']").attr('aria-selected', 'false');
    this.itemAt(i).attr('aria-selected', 'true');
    this.patchedMarkSelected(i);
  };

  /***
   * renderItemsInGroups and renderItemsFlat method replacement to enhance the item behaviors
   */
  TinyAutocomplete.prototype.renderItemsInGroups = function () {
    var v = this.field.val();
    for (var i = 0; i < this.json.length; i++) {
      var group = this.el.find(this.settings.groupContentName).eq(i);
      for (var j = 0; j < this.json[i].data.length && j < this.settings.maxItems; j++) {
        var jsonData = $.extend({}, this.json[i].data[j]), item;
        // Strongify hits
        if (this.settings.markAsBold) {
          jsonData = this.markHitText(jsonData, v)
        }

        item = $(this.settings.templateMethod(this.json[i].template || this.settings.itemTemplate, jsonData));
        this.addItemBehaviors(item);
        group.append(item);
      }
    }
  };

  TinyAutocomplete.prototype.renderItemsFlat = function () {
    this.list.remove();
    this.list = $('<ul class="autocomplete-list" />');
    var v = this.field.val();
    for (var i = 0; i < this.json.length && i < this.settings.maxItems; i++) {
      var jsonData = $.extend({}, this.json[i]), item;
      // Strongify hits
      if (this.settings.markAsBold) {
        jsonData = this.markHitText(jsonData, v)
      }
      item = this.settings.templateMethod(this.json[i].template || this.settings.itemTemplate, jsonData);
      this.addItemBehaviors(item);
      this.list.append(item);
    }
    this.el.append(this.list);
  };

  /***
   * New addItemBehaviors method that adds extra behaviors based on the focus and enter keydown
   * @param item
   */
  TinyAutocomplete.prototype.addItemBehaviors = function(item){
    item.on('focus', (function (that, item) {
      return function () {
        var idx = that.el.find('.autocomplete-item').index(item);
        that.selectedItem = idx;
        that.markSelected(idx)
      }
    })(this, item));

    item.on('keydown', (function (that) {
      return function (evt) {
        if (evt.keyCode === 13 && event.currentTarget === event.target) {  // Enter
          if (that.selectedItem === null) {
            return true;
          }
          evt.preventDefault();
          that.onSelect(that.itemAt(that.selectedItem), that.items[that.selectedItem]);
        }
      }
    })(this));
  };

  $.tinyAutocomplete = TinyAutocomplete;

})(window, $);
